import { ChangeDetectionStrategy, Component, EventEmitter, Input, OnChanges, Output, SimpleChanges } from '@angular/core';
import { UntypedFormControl, UntypedFormGroup } from '@angular/forms';

import { ICustomer } from '@ruby/modules/customer-select/models/customer.interface';
import { IServiceRequest } from '@ruby/modules/service-request/models/service-request.interface';
import { EAccrualType, EInventoryRoute } from '@ruby/shared/enums/inventory-management.enums';
import { IInventoryHeaderConfig } from '@ruby/shared/models/inventory-management/inventory-header.interface';
import { UtilsService } from '@ruby/shared/services/utils/utils.service';

@Component({
  selector: 'ng-header-summary',
  templateUrl: './header-summary.component.html',
  styleUrls: ['./header-summary.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class HeaderSummaryComponent implements OnChanges {
  @Input() config!: IInventoryHeaderConfig;
  @Input() customerSelected!: ICustomer;
  @Input() accrualSelected!: EAccrualType;
  @Input() type!: EInventoryRoute;
  @Output() serviceType = new EventEmitter<IServiceRequest>();
  @Output() monitorDate = new EventEmitter<number>();
  @Output() disputeDate = new EventEmitter<number>();
  @Output() billingDate = new EventEmitter<number>();
  @Output() accrual = new EventEmitter<EAccrualType>();
  pastTwelveMonths: Array<{ name: string; id: number }>;
  pastThirteenMonths: Array<{ name: string; id: number }>;
  minDate = new Date(this.utilSvc.getPreviousDate(6));
  previousMonthStartDate!: { name: string; id: number };
  currentMonthStartDate!: { name: string; id: number };
  serviceForm = new UntypedFormGroup({
    startDate: new UntypedFormControl(this.utilSvc.getPreviousMonthStartDate()),
    endDate: new UntypedFormControl(this.utilSvc.getPreviousMonthEndDate()),
    reportType: new UntypedFormControl('O')
  });

  constructor(private utilSvc: UtilsService) {
    this.pastTwelveMonths = this.utilSvc.getMonths(11);
    this.pastThirteenMonths = this.utilSvc.getMonths(12);
    this.previousMonthStartDate = this.pastTwelveMonths[0];
    this.currentMonthStartDate = this.pastThirteenMonths[0];
  }

  ngOnChanges(changes: SimpleChanges): void {
    if ((changes.customerSelected && changes.customerSelected.currentValue) || (changes.type && changes.type.currentValue)) {
      this.reset();
      this.previousMonthStartDate = this.pastTwelveMonths[0];
      this.currentMonthStartDate = this.pastThirteenMonths[0];
    }
  }

  /**
   * Total
   *
   * @summary Returns formatted total count
   * @param $total: number
   * @returns string
   */
  total($total: number): string {
    return $total && $total < 0 ? `(${ Math.abs($total) })` : $total.toString();
  }

  /**
   * Emit
   *
   * @summary Reset's the form and emits service type
   * @param $serviceType: string
   * @returns void
   */
  emit($serviceType: string): void {
    const form: { startDate: Date; endDate: Date } = this.serviceForm.value;
    this.serviceType.emit({
      startDate: $serviceType === 'H' ? form.startDate.getTime() : this.utilSvc.getPreviousMonthStartDate().getTime(),
      endDate: $serviceType === 'H' ? form.endDate.getTime() : this.utilSvc.getPreviousMonthEndDate().getTime(),
      history: $serviceType === 'H'
    } as IServiceRequest);
    if ($serviceType === 'O') {
      this.reset();
    }
  }

  private reset(): void {
    this.serviceForm.patchValue({
      startDate: this.utilSvc.getPreviousMonthStartDate(),
      endDate: this.utilSvc.getPreviousMonthEndDate(),
      reportType: 'O'
    });
  }
}
